/**
 * dataLayer GA4 + Meta — Avelyn Jewelry (tema Broadcast 6.2)
 *
 * Único sítio que faz pushes ao dataLayer e que gera event_id.
 * Os dados crus vêm do window.GTMDL (snippets/gtm-datalayer.liquid).
 *
 * Carregado SÍNCRONO no <head>, logo a seguir ao GTMDL e ao gtm.js: precisa de
 * embrulhar o fetch/XHR antes de o tema fazer o primeiro pedido ao carrinho.
 *
 * Cobre até ao carrinho. Checkout e compra vivem no Custom Pixel.
 */
(function () {
  'use strict';

  var DL = (window.dataLayer = window.dataLayer || []);
  var D = window.GTMDL || {};
  var MOEDA = D.currency || 'CAD';

  // ---------------------------------------------------------------- utilidades

  function novoId() {
    try {
      return crypto.randomUUID();
    } catch (e) {
      return 'e-' + Date.now() + '-' + Math.random().toString(16).slice(2);
    }
  }

  /** Payload do Meta a partir dos itens GA4 — pronto a usar nas tags, sem transformações no GTM. */
  function meta(itens, valor, eventId) {
    return {
      event_id: eventId,
      event_source_url: location.href,
      content_type: 'product',
      content_ids: itens.map(function (i) { return i.item_id; }),
      contents: itens.map(function (i) {
        return { id: i.item_id, quantity: i.quantity || 1, item_price: i.price };
      }),
      content_name: itens.length === 1 ? itens[0].item_name : undefined,
      content_category: itens.length ? itens[0].item_category : undefined,
      num_items: itens.reduce(function (s, i) { return s + (i.quantity || 1); }, 0),
      value: valor,
      currency: MOEDA
    };
  }

  function valorDe(itens) {
    return Math.round(itens.reduce(function (s, i) {
      return s + (i.price || 0) * (i.quantity || 1);
    }, 0) * 100) / 100;
  }

  /** O push. `ecommerce: null` primeiro — sem isto os itens do evento anterior colam-se ao seguinte. */
  function push(evento, itens, extra) {
    var lista = itens || [];
    var valor = (extra && typeof extra.value === 'number') ? extra.value : valorDe(lista);
    var id = (extra && extra.event_id) || novoId();

    DL.push({ ecommerce: null });
    DL.push(Object.assign({
      event: evento,
      ecommerce: Object.assign({ currency: MOEDA, value: valor, items: lista }, (extra && extra.ecommerce) || {}),
      meta: meta(lista, valor, id)
    }, (extra && extra.raiz) || {}));
  }

  // ------------------------------------------------- contexto e eventos de página

  DL.push({
    event: 'contexto_pagina',
    page_type: D.page_type || 'outro',
    logged_in: !!D.logged_in,
    cart_total: D.cart ? D.cart.total_value : 0,
    cart_quantity: D.cart ? D.cart.total_quantity : 0
  });

  if (D.product && D.product.item) push('view_item', [D.product.item]);

  if (D.template === 'cart' && D.cart && D.cart.items.length) {
    push('view_cart', D.cart.items, { value: D.cart.total_value });
  }

  if (D.search && D.search.term) {
    DL.push({ event: 'search', search_term: D.search.term, search_results: D.search.results });
  }

  // Troca de variante na página de produto → atualiza o item "ativo"
  var itemAtivo = D.product ? D.product.item : null;
  document.addEventListener('theme:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || !D.product) return;
    var achado = D.product.variants.filter(function (x) { return String(x.id) === String(v.id); })[0];
    if (achado) itemAtivo = achado.item;
  });

  // ------------------------------------------------------------ view_item_list
  // IntersectionObserver em vez de Liquid: cobre paginação AJAX, filtros,
  // quick view e carrosséis — tudo o que é injetado depois do load.

  var vistos = {};
  var pendentes = [];
  var timer = null;

  function despacharLista() {
    timer = null;
    if (!pendentes.length) return;
    var porLista = {};
    pendentes.forEach(function (p) {
      var chave = p.list_id + '|' + p.list_name;
      (porLista[chave] = porLista[chave] || []).push(p.item);
    });
    pendentes = [];
    Object.keys(porLista).forEach(function (chave) {
      var itens = porLista[chave].sort(function (a, b) { return (a.index || 0) - (b.index || 0); });
      push('view_item_list', itens, {
        ecommerce: { item_list_id: chave.split('|')[0], item_list_name: chave.split('|')[1] }
      });
    });
  }

  var observer = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      observer.unobserve(el);
      var item;
      try { item = JSON.parse(el.getAttribute('data-gtm-item')); } catch (err) { return; }
      var chave = (item.item_id || '') + '@' + (el.getAttribute('data-gtm-list-id') || '');
      if (vistos[chave]) return;
      vistos[chave] = 1;

      var cont = el.closest('[data-gtm-list-id]') || el.closest('.shopify-section');
      var listId = (cont && cont.getAttribute('data-gtm-list-id')) || (D.list && D.list.id) || (cont && cont.id) || 'lista';
      var listName = (cont && cont.getAttribute('data-gtm-list-name')) || (D.list && D.list.name) ||
        (cont && cont.querySelector('h1,h2,h3') ? cont.querySelector('h1,h2,h3').textContent.trim() : listId);

      item.index = item.index || (pendentes.length + 1);
      pendentes.push({ item: item, list_id: listId, list_name: listName });
      clearTimeout(timer);
      timer = setTimeout(despacharLista, 400);
    });
  }, {
    // 0.25 e não 0.5: um cartão de produto do Broadcast tem ~460 px e em mobile
    // chega a ser mais alto que o viewport — com 0.5 nunca chegaria a "visto".
    threshold: 0.25,
    rootMargin: '0px 0px -10% 0px'
  }) : null;

  function observarCartoes() {
    if (!observer) return;
    document.querySelectorAll('[data-gtm-item]:not([data-gtm-visto])').forEach(function (el) {
      el.setAttribute('data-gtm-visto', '1');
      observer.observe(el);
    });
  }

  // select_item — clique num cartão de produto
  document.addEventListener('click', function (e) {
    var cartao = e.target.closest && e.target.closest('[data-gtm-item]');
    if (!cartao) return;
    try { push('select_item', [JSON.parse(cartao.getAttribute('data-gtm-item'))]); } catch (err) {}
  }, true);

  // ------------------------------------------------- interceção dos pedidos /cart
  // Mais fiável do que os eventos do tema: apanha o tema, as apps e o quick add.

  var estado = {};   // variant_id -> quantidade  (agregado por VARIANTE, nunca por line.key:
                     //  a key muda sozinha quando há descontos automáticos)
  var itensPorVariante = {};

  function guardarEstado(carrinho) {
    estado = {};
    (carrinho.items || []).forEach(function (l) {
      var id = String(l.variant_id);
      estado[id] = (estado[id] || 0) + l.quantity;
      itensPorVariante[id] = itemDaLinha(l);
    });
  }

  function itemDaLinha(l) {
    return {
      item_id: String(l.variant_id),
      item_name: l.product_title || l.title,
      item_brand: l.vendor,
      item_category: l.product_type || 'Sem categoria',
      item_variant: l.variant_title || '',
      price: (l.final_price != null ? l.final_price : l.price) / 100,
      quantity: l.quantity,
      product_id: String(l.product_id),
      sku: l.sku || ''
    };
  }

  function diferenca(carrinho) {
    var antes = estado;
    var depois = {};
    (carrinho.items || []).forEach(function (l) {
      var id = String(l.variant_id);
      depois[id] = (depois[id] || 0) + l.quantity;
      itensPorVariante[id] = itemDaLinha(l);
    });

    var adicionados = [], removidos = [];
    Object.keys(Object.assign({}, antes, depois)).forEach(function (id) {
      var d = (depois[id] || 0) - (antes[id] || 0);
      if (d === 0) return;
      var base = itensPorVariante[id];
      if (!base) return;
      var copia = Object.assign({}, base, { quantity: Math.abs(d) });
      (d > 0 ? adicionados : removidos).push(copia);
    });

    estado = depois;
    if (adicionados.length) push('add_to_cart', adicionados);
    if (removidos.length) push('remove_from_cart', removidos);
  }

  function tratarResposta(url, corpo) {
    try {
      var dados = typeof corpo === 'string' ? JSON.parse(corpo) : corpo;
      if (!dados) return;

      if (/\/cart\/add(\.js)?/.test(url)) {
        // O add.js devolve o ITEM adicionado (ou {items:[…]}), não o carrinho
        var novos = dados.items ? dados.items : [dados];
        var itens = novos.filter(function (l) { return l && l.variant_id; }).map(itemDaLinha);
        if (itens.length) push('add_to_cart', itens);
        // ressincroniza em silêncio a seguir ao add
        fetch('/cart.js', { headers: { 'X-GTMDL-Silencio': '1' } })
          .then(function (r) { return r.json(); }).then(guardarEstado).catch(function () {});
        return;
      }

      if (/\/cart\/(change|update)(\.js)?/.test(url) && dados.items) diferenca(dados);
    } catch (e) {}
  }

  var fetchOriginal = window.fetch;
  if (fetchOriginal) {
    window.fetch = function (entrada, opcoes) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var silencioso = opcoes && opcoes.headers && opcoes.headers['X-GTMDL-Silencio'];
      var p = fetchOriginal.apply(this, arguments);
      if (!silencioso && /\/cart\/(add|change|update)/.test(url)) {
        p.then(function (r) {
          r.clone().text().then(function (t) { tratarResposta(url, t); }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }

  var abrirOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this.__gtmUrl = url;
    return abrirOriginal.apply(this, arguments);
  };
  var enviarOriginal = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (/\/cart\/(add|change|update)/.test(xhr.__gtmUrl || '')) {
      xhr.addEventListener('load', function () { tratarResposta(xhr.__gtmUrl, xhr.responseText); });
    }
    return enviarOriginal.apply(this, arguments);
  };

  // ----------------------------------------------------------- begin_checkout

  document.addEventListener('click', function (e) {
    var alvo = e.target.closest && e.target.closest(
      '[name="checkout"], [href*="/checkout"], [data-checkout-button], .cart__checkout'
    );
    if (!alvo) return;
    fetch('/cart.js', { headers: { 'X-GTMDL-Silencio': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c.items || !c.items.length) return;
        push('begin_checkout', c.items.map(itemDaLinha), { value: c.total_price / 100 });
      }).catch(function () {});
  }, true);

  // ---------------------------------------------------------------- arranque

  function arrancar() {
    observarCartoes();
    if (D.cart && D.cart.items) {
      D.cart.items.forEach(function (i) {
        estado[i.item_id] = (estado[i.item_id] || 0) + i.quantity;
        itensPorVariante[i.item_id] = i;
      });
    }
    // Rede de segurança para HTML injetado depois (filtros, paginação, quick view)
    if (window.MutationObserver) {
      new MutationObserver(function () { observarCartoes(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  ['collection:reloaded', 'recommendations:loaded', 'theme:quick-add:open'].forEach(function (ev) {
    document.addEventListener(ev, observarCartoes);
  });
})();
